import { clsx } from 'clsx';
import { useController, useLightboxState } from 'yet-another-react-lightbox';
import { Icon } from '../Icon';
import styles from './Gallery.module.scss';

export const GalleryButton = ({ variant, className }: { variant: 'next' | 'prev'; className?: string }) => {
  const controller = useController();
  const { currentIndex, slides } = useLightboxState();

  const galleryEvent = (variant: 'next' | 'prev') => {
    controller[variant]({ count: undefined });
  };

  return (
    <button
      className={clsx(styles.button, [className], [variant === 'next' ? styles.right : styles.left])}
      onClick={() => galleryEvent(variant)}
      disabled={variant === 'next' ? currentIndex === slides.length - 1 : currentIndex === 0}
    >
      {variant === 'next' ? (
        <Icon className={styles['gallery-icon']} name="chevronRight" />
      ) : (
        <Icon className={styles['gallery-icon']} name="chevronLeft" />
      )}
    </button>
  );
};
